import { Gondor } from "../Gondor";

const ACTIONS = {
  STUDIES_FIELD: "/StudiesField/",
  STUDIES_FIELD_ITEM: "/StudiesField/{id}/",
  ADD_SYSTEMS: "/StudiesField/add/system",
  REMOVE_SYSTEMS: "/StudiesField/remove/system",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.STUDIES_FIELD, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.STUDIES_FIELD_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.STUDIES_FIELD, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(ACTIONS.STUDIES_FIELD_ITEM.replace("{id}", id), body);
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.STUDIES_FIELD_ITEM.replace("{id}", id));
}

export function addSystems(body: object) {
  return Gondor.API.post(ACTIONS.ADD_SYSTEMS, body);
}

export function removeSystems(body: object) {
  return Gondor.API.post(ACTIONS.REMOVE_SYSTEMS, body);
}
